import { END_POINT } from "../../../config/environment";

export type SmartScreenRule = {
  label?: string;
  status?: boolean;
  message?: string;
  packageCount?: number | null;
  packageBalance?: number | null;
};

/**
 * True when the API says this metered feature is not available (e.g. no balance left).
 * Unlimited plans use status true with null counts.
 */
export function isSmartScreenExhausted(
  rule: SmartScreenRule | null | undefined,
): boolean {
  if (rule == null) return false;
  return rule.status === false;
}

export async function fetchSmartScreenRule(
  token: string,
): Promise<SmartScreenRule | null> {
  const res = await fetch(
    `${END_POINT.BASE_URL}/v1/subscription-rules/status?label=smart_screen`,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
  if (!res.ok) return null;
  const data: { rules?: SmartScreenRule[] } = await res.json();
  return data.rules?.[0] ?? null;
}
